import { render, staticRenderFns } from "./sportsInformation.vue?vue&type=template&id=08f0ff9e&scoped=true&"
import script from "./sportsInformation.vue?vue&type=script&lang=js&"
export * from "./sportsInformation.vue?vue&type=script&lang=js&"
import style0 from "./sportsInformation.vue?vue&type=style&index=0&id=08f0ff9e&prod&scoped=true&lang=css&"
import style1 from "./sportsInformation.vue?vue&type=style&index=1&id=08f0ff9e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f0ff9e",
  null
  
)

export default component.exports